import { FieldValuesResponse, LoadFieldValuesRequest } from '@cs-cms/types';
import { useMutation, UseMutationResult } from '@tanstack/react-query';
import { useContext } from 'react';
import ServicesContext from '../../contexts/ServicesContext';
import { mutateFieldsKeys } from '../../mutationKeys/fields';

export function useLoadFieldValues(): UseMutationResult<
  FieldValuesResponse,
  unknown,
  { fieldId: number; request: LoadFieldValuesRequest },
  unknown
> {
  const servicesCtx = useContext(ServicesContext);

  const loadFieldValues = (fieldId: number, request: LoadFieldValuesRequest) => {
    if (servicesCtx?.fieldsService) {
      return servicesCtx.fieldsService.loadFieldValues(fieldId, request);
    }
    throw new Error('Services context not initialized');
  };

  return useMutation({
    mutationKey: mutateFieldsKeys.loadFieldValues,
    mutationFn: ({ fieldId, request }) => loadFieldValues(fieldId, request)
  });
}
